import Icon from '@/components/ui/AppIcon';

const contactMethods = [
  {
    id: 'contact_email',
    icon: 'EnvelopeIcon',
    title: 'Email Us',
    value: 'support@shiptrack.com',
    description: 'Response within 24 hours',
  },
  {
    id: 'contact_phone',
    icon: 'PhoneIcon',
    title: 'Call Us',
    value: '+1-800-SHIPTRACK',
    description: 'Mon-Fri, 8AM-8PM EST',
  },
  {
    id: 'contact_chat',
    icon: 'ChatBubbleLeftRightIcon',
    title: 'Live Chat',
    value: 'Available 24/7',
    description: 'Instant AI support',
  },
];

const offices = [
  {
    id: 'office_us',
    city: 'New York',
    country: 'USA',
    address: '123 Shipping Lane, NY 10001',
    flag: '🇺🇸',
  },
  {
    id: 'office_uk',
    city: 'London',
    country: 'UK',
    address: '456 Logistics Road, EC1A 1BB',
    flag: '🇬🇧',
  },
  {
    id: 'office_jp',
    city: 'Tokyo',
    country: 'Japan',
    address: '789 Transport Street, 100-0001',
    flag: '🇯🇵',
  },
];

export default function ContactInfo() {
  return (
    <div className="space-y-6">
      {/* Contact Methods */}
      <div className="bg-card rounded-xl p-6 shadow-card border border-border">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-6">Get in Touch</h2>
        <div className="space-y-4">
          {contactMethods.map((method) => (
            <div key={method.id} className="flex items-start gap-4 p-4 rounded-lg hover:bg-muted transition-colors">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center shrink-0">
                <Icon name={method.icon as any} size={24} className="text-primary" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1">{method.title}</h3>
                <p className="text-foreground font-medium mb-1">{method.value}</p>
                <p className="text-sm text-muted-foreground">{method.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Office Locations */}
      <div className="bg-card rounded-xl p-6 shadow-card border border-border">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-6">Office Locations</h2>
        <div className="space-y-4">
          {offices.map((office) => (
            <div key={office.id} className="flex items-start gap-3 p-4 rounded-lg hover:bg-muted transition-colors">
              <span className="text-3xl">{office.flag}</span>
              <div>
                <h3 className="font-semibold text-foreground">
                  {office.city}, {office.country}
                </h3>
                <p className="text-sm text-muted-foreground">{office.address}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Business Hours */}
      <div className="bg-gradient-to-br from-primary to-primary/80 rounded-xl p-6 text-primary-foreground">
        <div className="flex items-center gap-3 mb-4">
          <Icon name="ClockIcon" size={24} />
          <h3 className="text-lg font-semibold">Business Hours</h3>
        </div>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span>Monday - Friday</span>
            <span className="font-medium">8:00 AM - 8:00 PM EST</span>
          </div>
          <div className="flex justify-between">
            <span>Saturday</span>
            <span className="font-medium">9:00 AM - 5:00 PM EST</span>
          </div>
          <div className="flex justify-between">
            <span>Sunday</span>
            <span className="font-medium">Closed</span>
          </div>
        </div>
      </div>
    </div>
  );
}